export default __webpack_public_path__ + "static/media/circle.80092caf.svg";